/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterImportRequest } from '../../models/profile-newsletter-import-request';
import { ProfileNewsletterImportResponse } from '../../models/profile-newsletter-import-response';

export interface ProfileNewsletterTestImport$Params {
  id: number;
      body: ProfileNewsletterImportRequest
}

export function profileNewsletterTestImport(http: HttpClient, rootUrl: string, params: ProfileNewsletterTestImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterImportResponse>> {
  const rb = new RequestBuilder(rootUrl, profileNewsletterTestImport.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterImportResponse>;
    })
  );
}

profileNewsletterTestImport.PATH = '/rest/profile/{id}/newsletter/test-import';
